export default {
  saveAllLoading ({
    commit
  }, data) {
    commit('SAVE_ALLSLOADING', data);
  },
  saveLogined ({
    commit
  }, data) {
    commit('SAVE_LOGINED', data);
  },
  saveIsBindCard ({
    commit
  }, data) {
    commit('SAVE_ISBINDCARD', data);
  }

}



// WEBPACK FOOTER //
// ./src/store/actions.js